export default __webpack_public_path__ + "static/media/app5.3277311f.png";